import io from "socket.io-client";
import axios from 'axios';
import { fetchInbox } from '../store/slices/notificationReducer';
import { initializeApp } from "firebase/app";

import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';

let messagingInstance;
async function getMessagingInstance() {
  try {
    if (messagingInstance) return messagingInstance;
    const { data } = await axios.get(`/api/firebase`)
    const app = initializeApp(data);
    messagingInstance = getMessaging(app);
    return messagingInstance;
  } catch (e) {
    console.error('Unable to retrieve firebase config: /api/firebase');
  }
}

const socketConnection = (user, socketInfo, navigate, dispatch) => {
  getMessagingInstance().then((messaging) => {
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
    });
  })
  const socket = io(socketInfo.url, {
    transports: ['websocket'],
    upgrade: false
  });
  socket.on('connect', function () {
    socket.emit('authorization', `Bearer ${socketInfo.token.token}`);
  });
  socket.on('notification', function (message) {
    try {
      // update counter (if tab is visible) don't notificatate
      if (!document.hidden) {
        dispatch(fetchInbox());
      }
      // navigator.serviceWorker.getRegistration().then((registration) => {
      //   registration.showNotification(message.message, {
      //     // body: payload.data.body,
      //     icon: "https://cdn.antwerpen.be/core_branding_scss/6.4.0/assets/images/a-logo.svg",
      //     tag: message.link.url
      //   })
      // })
    } catch (e) {
      alert(e);
    }
  });
  socket.on("connect_error", () => {
    setTimeout(() => {
       socket.connect();
    }, 1000);
  });
  socket.connect();
  return socket;
}

export const listenForNotifications = (user, socket, navigate, dispatch) => {
  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification");
  } else if (Notification.permission === "granted") {
    return socketConnection(user, socket, navigate, dispatch);
  }
}

export const requestToken = async () => {
  const messaging = await getMessagingInstance();
  const token = await getToken(messaging);
  return token;
}

export const requestNotifications = async () => {
  const messaging = await getMessagingInstance();
  const support = await isSupported();
  if (!support) {
    console.log("This browser does not support desktop notification");
  } else if (Notification.permission === "granted") {
    return getToken(messaging)
      .then((currentToken) => {
        if (currentToken) {
          return { activate: true, token: currentToken }
        } else {
          console.log('Failed to generate the app registration token.');
        }
      })
      .catch((err) => {
        console.log('An error occurred when requesting to receive the token.', err);
        return { activate: false }
      });
  } else if (Notification.permission === "default") {
    // We need to ask the user for permission
    return Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        return getToken(messaging)
          .then((currentToken) => {
            if (currentToken) {
              return { activate: true, token: currentToken }
            } else {
              console.log('Failed to generate the app registration token.');
            }
          })
          .catch((err) => {
            console.log('An error occurred when requesting to receive the token.', err);
            return { activate: false }
          });
      }
      return { activate: false }
    });
  } else {
    return { activate: false }
  }
}
